import blockedCommands from '../../features/TextEditor/blockedCommands'

describe('blockedCommands', () => {
  it('should return underline true', () => {
    expect(blockedCommands.underline).toBeTruthy();
  })
})
